function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", {
  id: "fast-delivery_svg__defs250"
}, /*#__PURE__*/React.createElement("style", {
  id: "style248"
}, ".fast-delivery_svg__cls-1{fill:#5e4dad}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M90.53 56.95c-4.98 0-9.02-4.03-9.02-9.01 0-4.98 4.03-9.02 9.01-9.02 4.98 0 9.02 4.03 9.02 9.01 0 4.98-4.03 9.01-9.01 9.02zm0-14.74c-3.16 0-5.73 2.56-5.73 5.72 0 3.16 2.56 5.73 5.72 5.73 3.16 0 5.73-2.56 5.73-5.72 0-3.17-2.56-5.73-5.72-5.73z",
  id: "fast-delivery_svg__path252"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M43.03 56.95c-4.98 0-9.02-4.03-9.02-9 0-4.98 4.03-9.02 9-9.02 4.98 0 9.02 4.03 9.02 9s-4.03 9-9 9.01zm0-14.74a5.72 5.72 0 00-5.73 5.72 5.72 5.72 0 005.72 5.73 5.72 5.72 0 005.73-5.72c0-3.16-2.56-5.72-5.72-5.72z",
  id: "fast-delivery_svg__path254"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M102.38 49.58h-4.5c-.91 0-1.64-.74-1.64-1.64 0-.9.74-1.64 1.64-1.64h4.03v-8.72c0-1.18-.3-2.34-.88-3.37l-8.9-15.95a.867.867 0 00-.76-.45H79.24V46.3h3.91c.91 0 1.64.74 1.64 1.64 0 .9-.74 1.64-1.64 1.64h-5.56c-.91 0-1.64-.74-1.64-1.64V16.16c0-.91.74-1.64 1.64-1.64h13.77c1.51 0 2.9.82 3.64 2.13l8.9 15.96c.85 1.52 1.29 3.23 1.29 4.97v9.18c0 1.56-1.26 2.82-2.82 2.82z",
  id: "fast-delivery_svg__path256"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M35.67 49.58H19.91c-.91 0-1.64-.74-1.64-1.64V35.3c0-.91.74-1.64 1.64-1.64.9 0 1.64.74 1.64 1.64v11h14.12c.91 0 1.64.74 1.64 1.64 0 .9-.74 1.64-1.64 1.64z",
  id: "fast-delivery_svg__path258"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M19.91 29.47c-.91 0-1.64-.74-1.64-1.64V16.79c0-.91.74-1.64 1.64-1.64.9 0 1.64.74 1.64 1.64v11.04c0 .91-.74 1.64-1.64 1.64z",
  id: "fast-delivery_svg__path260"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M77.61 49.58H50.39c-.91 0-1.64-.74-1.64-1.64 0-.9.74-1.64 1.64-1.64h25.57V3.29H21.55v6.77c0 .91-.74 1.64-1.64 1.64-.9 0-1.64-.74-1.64-1.64V2.99c0-1.65 1.34-2.98 2.99-2.99h55.01c1.65 0 2.98 1.34 2.99 2.99v44.95c0 .91-.74 1.64-1.64 1.64z",
  id: "fast-delivery_svg__path262"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M26.41 36.94H5.54c-.91 0-1.64-.74-1.64-1.64 0-.9.74-1.64 1.64-1.64H26.4c.91 0 1.64.74 1.64 1.64 0 .9-.74 1.64-1.64 1.64z",
  id: "fast-delivery_svg__path264"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M43.03 29.47H13.92c-.91 0-1.64-.74-1.64-1.64 0-.9.74-1.64 1.64-1.64h29.11c.91 0 1.64.74 1.64 1.64 0 .9-.74 1.64-1.64 1.64z",
  id: "fast-delivery_svg__path266"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M13.01 20.79H1.64c-.91 0-1.64-.74-1.64-1.64 0-.9.74-1.64 1.64-1.64h11.37c.91 0 1.64.74 1.64 1.64 0 .9-.74 1.64-1.64 1.64z",
  id: "fast-delivery_svg__path268"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "fast-delivery_svg__cls-1",
  d: "M31.24 11.71H11.17c-.91 0-1.64-.74-1.64-1.64 0-.9.74-1.64 1.64-1.64h20.07c.91 0 1.64.74 1.64 1.64 0 .9-.74 1.64-1.64 1.64z",
  id: "fast-delivery_svg__path270"
});

function SvgFastDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fast-delivery_svg__Warstwa_1",
    viewBox: "0 0 105.19 56.95",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

export default SvgFastDelivery;